import React from "react";
import styled from "styled-components/macro";
import AboutImageSrc from "./about.png";
import AboutMiddleSrc from "./about_middle.png";

const Wrapper = styled.div`
  width: calc(100% - 64px);
  max-width: 720px;
  margin: 0 auto;
  padding: 120px 0 120px;
`;

const H1 = styled.h1`
  font-size: 32px;
  font-weight: 500;
`;

const Section = styled.section`
  padding: 24px 0;
`;

const H2 = styled.h2`
  font-size: 24px;
  margin-bottom: 16px;
`;

const H3 = styled.h3`
  font-size: 20px;
  margin-bottom: 8px;
`;

const Paragraph = styled.p`
  font-size: 16px;
  line-height: 24px;

  b {
    font-weight: 500;
  }
`;

const Anchor = styled.a`
  color: ${({ theme }) => theme.palette.blue500};
  &:hover {
    text-decoration: underline;
  }
`;

const Image = styled.img`
  display: block;
  width: 100%;
  margin-bottom: 32px;
`;

export function About() {
  return (
    <Wrapper>
      <H1>About Yess</H1>
      <Section>
        <Image src={AboutImageSrc} />
        <Paragraph>
          Yess is the{" "}
          <b>BizOps suite for freelancers, studios, and agencies.</b> Yess
          streamlines the end-to-end workflow and removes the operation cost of
          the quote-to-cash process.
          <br />
          <br />
          <H3>Problem</H3>
          In-house work changes into B2B transactions, and this external
          workflow is complicated and takes a lot of operational costs. However,
          there’s no effective or practical solution to manage this process,
          which is getting more complicated.
          <br />
          <br />
          <H3>Solution</H3>
          Yess re-bundles the legacy solutions, including both software and
          human resources, better and cheaper. It is an operating system
          optimized for client-facing projects. Yess automates the operation,
          integrates features and data, and supports flexible organizations.
          <br />
          <br />
          <H3>Roadmap</H3>
          Yess will become the standard for external workflows or
          business-to-talent transactions. There will be no friction or
          limitation to working on projects with anyone outside.
        </Paragraph>
      </Section>
      <Section>
        <Image src={AboutMiddleSrc} />
        <H2>Our Vision</H2>
        <Paragraph>
          Yess is where talents become entrepreneurs.
          <br />
          <br />
          As the world, including the labor market, gets decentralized,
          flexibility matters the most to companies and workers. It is a new
          movement that younger professionals are more willing to live as
          entrepreneurs.
          <br />
          <br />
          <b>Yess is about saying no, and it is about freedom.</b> Anyone can
          start something easily, but the thing is to sustain and grow. Yess
          encourages you to overcome obstacles and focus on the right thing by
          supporting the right tool at the right time.
          <br />
          <br />
          Yess turns possibility into reality. If Yess succeeds,{" "}
          <b>
            millions of entrepreneurs will be born, and billions of successful
            projects will follow.
          </b>{" "}
          We believe it will contribute to the diversity and dynamics of the
          world and conclusively to freedom.
          <br />
          <br />
          Yess hopes to become <b>the most loved brand</b>, beyond software, by
          the next-gen professionals.
        </Paragraph>
      </Section>
      <Section>
        <H2>Our Investors</H2>
        <Paragraph>
          Ambitious founders and investors were thrilled to join the ambitious
          journey of Yess. We raised a <b>$2M</b> seed round led by Transpose
          Platform, a $2B Silicon Valley-based VC, and backed by serial
          entrepreneurs like John S. Kim, Alex Haro, Sumon Sadhu, Khaled
          Hussein, Chris Nguyen, and Changwook Kim.
        </Paragraph>
      </Section>
      <Section>
        <H2>Contact</H2>
        <Paragraph>
          If you’re a talented problem solver with a similar vision, please
          don’t hesitate to join in building the future of work by yourself.
          <br />
          <br />
          <Anchor href="mailto:support@yess.io">support@yess.io</Anchor>
        </Paragraph>
      </Section>
    </Wrapper>
  );
}
